import { createFromIconfontCN } from "@ant-design/icons";

const Icon = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_4020454_t8uize6pn9f.js", // 在 iconfont.cn 上生成
});

export default Icon;
